import { object, string } from 'yup'

export const paymentSchema = object({
    paymentMethod: string()
        .required(),
    cardDetails: string()
        .required()
})